import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Employee, CarBrand, CarType, Importer, Insurance, JobType, Receiver} from '../../../models/models';
import {LoginService} from '../../../services/login.service';
import {DamageAdministrationService} from '../../../services/damage-administration.service';
import {CheckService} from '../../../services/check.service';
import {ColumnModel, EditSettingsModel, GridComponent, ToolbarItems} from '@syncfusion/ej2-angular-grids';
import {ClickEventArgs} from '@syncfusion/ej2-angular-navigations';
import {DatePipe} from '@angular/common';
import {MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig} from '@angular/material/legacy-dialog';
import {forkJoin} from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-damage-administration-core-data',
  templateUrl: './damage-administration-core-data.component.html',
  styleUrls: ['./damage-administration-core-data.component.css'],
  providers: [DatePipe]
})
export class DamageAdministrationCoreDataComponent implements OnInit {
  @ViewChild('employeeDialog', {static: true}) employeeDialog: TemplateRef<MatDialog>;
  @ViewChild('carTypeDialog', {static: true}) carTypeDialog: TemplateRef<MatDialog>;
  @ViewChild('carBrandDialog', {static: true}) carBrandDialog: TemplateRef<MatDialog>;
  @ViewChild('importerDialog', {static: true}) importerDialog: TemplateRef<MatDialog>;
  @ViewChild('insuranceDialog', {static: true}) insuranceDialog: TemplateRef<MatDialog>;
  @ViewChild('jobTypeDialog', {static: true}) jobTypeDialog: TemplateRef<MatDialog>;
  @ViewChild('receiverDialog', {static: true}) receiverDialog: TemplateRef<MatDialog>;
  @ViewChild('employeeGrid', {static: true}) private employeeGrid: GridComponent;
  @ViewChild('carTypeGrid', {static: true}) private carTypeGrid: GridComponent;
  @ViewChild('carBrandGrid', {static: true}) private carBrandGrid: GridComponent;
  @ViewChild('importerGrid', {static: true}) private importerGrid: GridComponent;
  @ViewChild('insuranceGrid', {static: true}) private insuranceGrid: GridComponent;
  @ViewChild('jobTypeGrid', {static: true}) private jobTypeGrid: GridComponent;
  @ViewChild('receiverGrid', {static: true}) private receiverGrid: GridComponent;

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private damageAdministrationService: DamageAdministrationService,
    private dialog: MatDialog
  ) { }

  public employee: Employee;
  public carType: CarType;
  public carBrand: CarBrand;
  public importer: Importer;
  public insurance: Insurance;
  public jobType: JobType;
  public receiver: Receiver;
  public employeeDataSource: Employee[] = [];
  public carTypeDataSource: CarType[] = [];
  public carBrandDataSource: CarBrand[] = [];
  public importerDataSource: Importer[] = [];
  public insuranceDataSource: Insurance[] = [];
  public jobTypeDataSource: JobType[] = [];
  public receiverDataSource: Receiver[] = [];
  public employeeColumns: ColumnModel[];
  public carTypeColumns: ColumnModel[];
  public carBrandColumns: ColumnModel[];
  public importerColumns: ColumnModel[];
  public insuranceColumns: ColumnModel[];
  public jobTypeColumns: ColumnModel[];
  public receiverColumns: ColumnModel[];
  public editSettings: EditSettingsModel;
  public toolbar: ToolbarItems[];
  public allowances = true;
  public config: MatDialogConfig = {width: '60vw'};
  public readonly = true;

  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkRight(9);
    this.loadData();
    this.initGrids();
  }

  loadData() {
    forkJoin([
      this.damageAdministrationService.getEmployees(),
      this.damageAdministrationService.getImporters(),
      this.damageAdministrationService.getCarBrands(),
      this.damageAdministrationService.getCarTypes(),
      this.damageAdministrationService.getInsurances(),
      this.damageAdministrationService.getJobTypes(),
      this.damageAdministrationService.getReceivers()
    ]).subscribe(([employeeResponse, importerResponse, carBrandResponse, carTypeResponse, insuranceResponse, jobTypeResponse, receiverResponse]) => {
      if (!employeeResponse.Ok || !importerResponse.Ok || !carBrandResponse.Ok || !carTypeResponse.Ok || !insuranceResponse.Ok || !jobTypeResponse.Ok || !receiverResponse.Ok) return;
      this.employeeDataSource = employeeResponse.Obj;
      this.importerDataSource = importerResponse.Obj;
      carBrandResponse.Obj.forEach(c => { c.ImporterName = this.importerDataSource.find(i => i.ImporterId === c.ImporterId).ImporterName; });
      this.carBrandDataSource = carBrandResponse.Obj;
      carTypeResponse.Obj.forEach(c => { c.CarBrandName = this.carBrandDataSource.find(i => i.CarBrandId === c.CarBrandId).CarBrandName; });
      this.carTypeDataSource = carTypeResponse.Obj;
      this.insuranceDataSource = insuranceResponse.Obj;
      this.jobTypeDataSource =jobTypeResponse.Obj;
      this.receiverDataSource = receiverResponse.Obj;
    });
  }

  loadEmployees() {
    this.damageAdministrationService.getEmployees().subscribe(response => {
      if (response.Ok) this.employeeDataSource = response.Obj;
      if (response.Ex) console.log(response.Ex);
      if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
    }), (error: any) => {
      console.log(error);
      this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
    };
  }
  loadCarTypes() {
    this.damageAdministrationService.getCarTypes().subscribe(response => {
      if (response.Ok) {
        response.Obj.forEach(c => { c.CarBrandName = this.carBrandDataSource.find(i => i.CarBrandId === c.CarBrandId).CarBrandName; });
        this.carTypeDataSource = response.Obj;
      }
      if (response.Ex) console.log(response.Ex);
      if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
    }), (error: any) => {
      console.log(error);
      this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
    };
  }
  loadCarBrands() {
    this.damageAdministrationService.getCarBrands().subscribe(response => {
      if (response.Ok) {
        response.Obj.forEach(c => {
          c.ImporterName = this.importerDataSource.find(i => i.ImporterId === c.ImporterId).ImporterName;
        });
        this.carBrandDataSource = response.Obj;
      }
      if (response.Ex) console.log(response.Ex);
      if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
    }), (error: any) => {
      console.log(error);
      this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
    };
  }
  loadImporters() {
    this.damageAdministrationService.getImporters().subscribe(response => {
      if (response.Ok) this.importerDataSource = response.Obj;
      if (response.Ex) console.log(response.Ex);
      if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
    }), (error: any) => {
      console.log(error);
      this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
    };
  }
  loadInsurances() {
    this.damageAdministrationService.getInsurances().subscribe(response => {
      if (response.Ok) this.insuranceDataSource = response.Obj;
      if (response.Ex) console.log(response.Ex);
      if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
    }), (error: any) => {
      console.log(error);
      this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
    };
  }
  loadJobTypes() {
    this.damageAdministrationService.getJobTypes().subscribe(response => {
      if (response.Ok) this.jobTypeDataSource = response.Obj;
      if (response.Ex) console.log(response.Ex);
      if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
    }), (error: any) => {
      console.log(error);
      this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
    };
  }
  loadReceivers() {
    this.damageAdministrationService.getReceivers().subscribe(response => {
      if (response.Ok) this.receiverDataSource = response.Obj;
      if (response.Ex) console.log(response.Ex);
      if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
    }), (error: any) => {
      console.log(error);
      this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
    };
  }

  initGrids() {
    this.toolbar = ['Add', 'Edit', 'Delete', 'Cancel', 'ExcelExport', 'PdfExport', 'Print', 'Search'];
    this.editSettings =  {
      allowAdding: true,
      allowEditing: true,
      allowDeleting: true,
      mode: 'Dialog',
      allowEditOnDblClick: true,
      showConfirmDialog: false,
      showDeleteConfirmDialog: false
    };
    this.employeeColumns = [
      {
        field: 'UniqueId',
        headerText: 'Mitarbeiter Id',
        textAlign: 'Left',
        isPrimaryKey: true,
        allowEditing: false,
      },
      {
        field: 'FirstName',
        headerText: 'Vorname',
        textAlign: 'Left'
      },
      {
        field: 'LastName',
        headerText: 'Nachname',
        textAlign: 'Left'
      },
      {
        field: 'UserName',
        headerText: 'Benutzername',
        textAlign: 'Left'
      },
      {
        field: 'IsActive',
        headerText: 'Aktiv',
        textAlign: 'Left',
        displayAsCheckBox: true,
        editType: 'boolean'
      },
      {
        field: 'IsWebUser',
        headerText: 'WebUser',
        textAlign: 'Left',
        displayAsCheckBox: true,
        editType: 'boolean'
      },
      {
        field: 'IsAdministrator',
        headerText: 'Administrator',
        textAlign: 'Left',
        displayAsCheckBox: true,
        editType: 'boolean'
      },
      {
        field: 'Password',
        headerText: 'Passwort',
        textAlign: 'Left'
      }
    ];
    this.carTypeColumns = [
      {
        field: 'CarTypeId',
        headerText: 'Fahrzeug Modell Id',
        textAlign: 'Left',
        isPrimaryKey: true,
        allowEditing: false,
      },
      {
        field: 'CarTypeName',
        headerText: 'Fahrzeug Modell',
        textAlign: 'Left'
      },
      {
        field: 'CarBrandId',
        headerText: 'Fahrzeug Marke Id',
        textAlign: 'Left',
        visible: false,
      },
      {
        field: 'CarBrandName',
        headerText: 'Fahrzeug Marke',
        textAlign: 'Left',
      }
    ];
    this.carBrandColumns = [
      {
        field: 'CarBrandId',
        headerText: 'Fahrzeug Marke Id',
        textAlign: 'Left',
        isPrimaryKey: true,
        allowEditing: false,
      },
      {
        field: 'CarBrandName',
        headerText: 'Fahrzeug Marke',
        textAlign: 'Left'
      },
      {
        field: 'ImporterId',
        headerText: 'Importeur Id',
        textAlign: 'Left',
        visible: false,
      },
      {
        field: 'ImporterName',
        headerText: 'Importeur',
        textAlign: 'Left'
      }
    ];
    this.importerColumns = [
      {
        field: 'ImporterId',
        headerText: 'Importeur Id',
        textAlign: 'Left',
        isPrimaryKey: true,
        allowEditing: false,
      },
      {
        field: 'ImporterName',
        headerText: 'Importeur Name',
        textAlign: 'Left'
      },
      {
        field: 'ImporterTransitId',
        headerText: 'Transit Importeur Id',
        textAlign: 'Left'
      }
    ];
    this.insuranceColumns = [
      {
        field: 'InsuranceId',
        headerText: 'Versicherungs Id',
        textAlign: 'Left',
        isPrimaryKey: true,
        allowEditing: false,
      },
      {
        field: 'InsuranceName',
        headerText: 'Versicherungsart',
        textAlign: 'Left'
      },
      {
        field: 'PoliceNo',
        headerText: 'Policen Nummer',
        textAlign: 'Left'
      }
    ];
    this.jobTypeColumns = [
      {
        field: 'JobTypeId',
        headerText: 'Auftragstyp Id',
        textAlign: 'Left',
        isPrimaryKey: true,
        allowEditing: false,
      },
      {
        field: 'JobTypeName',
        headerText: 'Auftragstyp Name',
        textAlign: 'Left'
      },
      {
        field: 'SqlSelect',
        headerText: 'SqlSelect',
        textAlign: 'Left'
      }
    ];
    this.receiverColumns = [
      {
        field: 'ReceiverId',
        headerText: 'Empfänger Id',
        textAlign: 'Left',
        isPrimaryKey: true,
        allowEditing: false,
      },
      {
        field: 'ReceiverName',
        headerText: 'Empfänger Name',
        textAlign: 'Left'
      },
      {
        field: 'Receiver_Id_Transit',
        headerText: 'Transit Empfänger Id',
        textAlign: 'Left'
      }
    ];
  }

  employeeActionBegin(args: any) {
    if (args.requestType === 'add') {
      args.cancel = true;
      this.addEmployee();
    }
    if (args.requestType === 'beginEdit') {
      args.cancel = true;
      this.editEmployee(args);
    }
    if (args.requestType === 'delete') {
      args.cancel = true;
      this.deleteEmployee(args);
    }
  }
  carTypeActionBegin(args: any) {
    if (args.requestType === 'add') {
      args.cancel = true;
      this.addCarType();
    }
    if (args.requestType === 'beginEdit') {
      args.cancel = true;
      this.editCarType(args);
    }
    if (args.requestType === 'delete') {
      args.cancel = true;
      this.deleteCarType(args);
    }
  }
  carBrandActionBegin(args: any) {
    if (args.requestType === 'add') {
      args.cancel = true;
      this.addCarBrand();
    }
    if (args.requestType === 'beginEdit') {
      args.cancel = true;
      this.editCarBrand(args);
    }
    if (args.requestType === 'delete') {
      args.cancel = true;
      this.deleteCarBrand(args);
    }
  }
  importerActionBegin(args: any) {
    if (args.requestType === 'add') {
      args.cancel = true;
      this.addImporter();
    }
    if (args.requestType === 'beginEdit') {
      args.cancel = true;
      this.editImporter(args);
    }
    if (args.requestType === 'delete') {
      args.cancel = true;
      this.deleteImporter(args);
    }
  }
  insuranceActionBegin(args: any) {
    if (args.requestType === 'add') {
      args.cancel = true;
      this.addInsurance();
    }
    if (args.requestType === 'beginEdit') {
      args.cancel = true;
      this.editInsurance(args);
    }
    if (args.requestType === 'delete') {
      args.cancel = true;
      this.deleteInsurance(args);
    }
  }
  jobTypeActionBegin(args: any) {
    if (args.requestType === 'add') {
      args.cancel = true;
      this.addJobType();
    }
    if (args.requestType === 'beginEdit') {
      args.cancel = true;
      this.editJobType(args);
    }
    if (args.requestType === 'delete') {
      args.cancel = true;
      this.deleteJobType(args);
    }
  }
  receiverActionBegin(args: any) {
    if (args.requestType === 'add') {
      args.cancel = true;
      this.addReceiver();
    }
    if (args.requestType === 'beginEdit') {
      args.cancel = true;
      this.editReceiver(args);
    }
    if (args.requestType === 'delete') {
      args.cancel = true;
      this.deleteReceiver(args);
    }
  }

  addEmployee() {
    this.employee = new Employee();
    this.employee.UniqueId = 0;
    this.dialog.open(this.employeeDialog, this.config);
  }
  addCarType() {
    this.carType = new CarType();
    this.carType.CarTypeId = 0;
    this.dialog.open(this.carTypeDialog, this.config);
  }
  addCarBrand() {
    this.carBrand = new CarBrand();
    this.carBrand.CarBrandId = 0;
    this.dialog.open(this.carBrandDialog, this.config);
  }
  addImporter() {
    this.importer = new Importer();
    this.importer.ImporterId = 0;
    this.dialog.open(this.importerDialog, this.config);
  }
  addInsurance() {
    this.insurance = new Insurance();
    this.insurance.InsuranceId = 0;
    this.dialog.open(this.insuranceDialog, this.config);
  }
  addJobType() {
    this.jobType = new JobType();
    this.jobType.JobTypeId = 0;
    this.dialog.open(this.jobTypeDialog, this.config);
  }
  addReceiver() {
    this.receiver = new Receiver();
    this.receiver.ReceiverId = 0;
    this.dialog.open(this.receiverDialog, this.config);
  }

  editEmployee(args: any) {
    this.employee = args.rowData;
    this.dialog.open(this.employeeDialog, this.config);
  }
  editCarType(args: any) {
    this.carType = args.rowData;
    this.dialog.open(this.carTypeDialog, this.config);
  }
  editCarBrand(args: any) {
    this.carBrand = args.rowData;
    this.dialog.open(this.carBrandDialog, this.config);
  }
  editImporter(args: any) {
    this.importer = args.rowData;
    this.dialog.open(this.importerDialog, this.config);
  }
  editInsurance(args: any) {
    this.insurance = args.rowData;
    this.dialog.open(this.insuranceDialog, this.config);
  }
  editJobType(args: any) {
    this.jobType = args.rowData;
    this.dialog.open(this.jobTypeDialog, this.config);
  }
  editReceiver(args: any) {
    this.receiver = args.rowData;
    this.dialog.open(this.receiverDialog, this.config);
  }

  deleteEmployee(args: any) {
    this.employee = args.data[0];
    Swal.fire({
      title: 'Löschen?',
      text: 'Möchten Sie diesen Mitarbeiter wirklich löschen' + ': ' + this.employee.FirstName + ' ' + this.employee.LastName + '?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Löschen',
      cancelButtonText: 'Abbrechen',
    }).then((result) => {
      if (result.value) {
        this.damageAdministrationService.deleteEmployee(this.employee.UniqueId).subscribe(response => {
          if (response.Ok) {
            if (!response.Obj)  this.toast.fire('Fehler', 'Mitarbeiter konnte nicht gelöscht werden.', 'error').then(r => this.loadEmployees());
            else this.toast.fire('Erfolg', 'Mitarbeiter erfolgreich gelöscht.', 'success').then(r => this.loadEmployees());
          }
          if (response.Ex) console.log(response.Ex);
          if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
        }), (error: any) => {
          console.log(error);
          this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
        };
      }
    });
  }
  deleteCarType(args: any) {
    this.carType = args.data[0];
    Swal.fire({
      title: 'Löschen?',
      text: 'Möchten Sie dieses Fahrzeug Modell wirklich löschen' + ': ' + this.carType.CarTypeName + '?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Löschen',
      cancelButtonText: 'Abbrechen',
    }).then((result) => {
      if (result.value) {
        this.damageAdministrationService.deleteCarType(this.carType.CarTypeId).subscribe(response => {
          if (response.Ok) {
            if (response.Obj) this.toast.fire('Erfolg', 'Fahrzeug Modell erfolgreich gelöscht.', 'success').then(r => this.loadCarTypes());
            else this.toast.fire('Fehler', 'Fahrzeug Modell konnte nicht gelöscht werden.', 'error').then(r => this.loadCarTypes());
          }
          if (response.Ex) console.log(response.Ex);
          if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
        }), (error: any) => {
          console.log(error);
          this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
        };
      }
    });
  }
  deleteCarBrand(args: any) {
    this.carBrand = args.data[0];
    Swal.fire({
      title: 'Löschen?',
      text: 'Möchten Sie diese Fahrzeug Marke wirklich löschen' + ': ' + this.carBrand.CarBrandName + '?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Löschen',
      cancelButtonText: 'Abbrechen',
    }).then((result) => {
      if (result.value) {
        this.damageAdministrationService.deleteCarBrand(this.carBrand.CarBrandId).subscribe(response => {
          if (response.Ok) {
            if (response.Ok) this.toast.fire('Erfolg', 'Fahrzeug Marke erfolgreich gelöscht.', 'success').then(r => this.loadCarBrands());
            else this.toast.fire('Fehler', 'Fahrzeug Marke konnte nicht gelöscht werden.', 'error').then(r => this.loadCarBrands());
          }
          if (response.Ex) console.log(response.Ex);
          if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
        }), (error: any) => {
          console.log(error);
          this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
        };
      }
    });
  }
  deleteImporter(args: any) {
    this.importer = args.data[0];
    Swal.fire({
      title: 'Löschen?',
      text: 'Möchten Sie diesen Importeur wirklich löschen' + ': ' + this.importer.ImporterName + '?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Löschen',
      cancelButtonText: 'Abbrechen',
    }).then((result) => {
      if (result.value) {
        this.damageAdministrationService.deleteImporter(this.importer.ImporterId).subscribe(response => {
          if (response.Ok) this.toast.fire('Erfolg', 'Importeur erfolgreich gelöscht.', 'success').then(r => this.loadImporters());
          else this.toast.fire('Fehler', 'Importeur konnte nicht gelöscht werden.', 'error').then(r => this.loadImporters());
          if (response.Ex) console.log(response.Ex);
          if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
        }), (error: any) => {
          console.log(error);
          this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
        };
      }
    });
  }
  deleteInsurance(args: any) {
    this.insurance = args.data[0];
    Swal.fire({
      title: 'Löschen?',
      text: 'Möchten Sie diese Versicherungsart wirklich löschen' + ': ' + this.insurance.InsuranceName + '?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Löschen',
      cancelButtonText: 'Abbrechen',
    }).then((result) => {
      if (result.value) {
        this.damageAdministrationService.deleteInsurance(this.insurance.InsuranceId).subscribe(response => {
          if (response.Ok) {
            if (response.Obj) this.toast.fire('Erfolg', 'Versicherungsart erfolgreich gelöscht.', 'success').then(r => this.loadInsurances());
            else this.toast.fire('Fehler', 'Versicherungsart konnte nicht gelöscht werden.', 'error').then(r => this.loadInsurances());
          }
          if (response.Ex) console.log(response.Ex);
          if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
        }), (error: any) => {
          console.log(error);
          this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
        };
      }
    });
  }
  deleteJobType(args: any) {
    this.jobType = args.data[0];
    Swal.fire({
      title: 'Löschen?',
      text: 'Möchten Sie diesen Auftragstyp wirklich löschen' + ': ' + this.jobType.JobTypeName + '?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Löschen',
      cancelButtonText: 'Abbrechen',
    }).then((result) => {
      if (result.value) {
        this.damageAdministrationService.deleteJobType(this.jobType.JobTypeId).subscribe(response => {
          if (response.Ok) {
            if (response.Obj) this.toast.fire('Fehler', 'Auftragstyp konnte nicht gelöscht werden.', 'error').then(r => this.loadJobTypes());
            else this.toast.fire('Erfolg', 'Auftragstyp erfolgreich gelöscht.', 'success').then(r => this.loadJobTypes());
          }
          if (response.Ex) console.log(response.Ex);
          if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
        }), (error: any) => {
          console.log(error);
          this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
        };
      }
    });
  }
  deleteReceiver(args: any) {
    this.receiver = args.data[0];
    Swal.fire({
      title: 'Löschen?',
      text: 'Möchten Sie diesen Empfänger wirklich löschen' + ': ' + this.receiver.ReceiverName + '?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Löschen',
      cancelButtonText: 'Abbrechen',
    }).then((result) => {
      if (result.value) {
        this.damageAdministrationService.deleteReceiver(this.receiver.ReceiverId).subscribe(response => {
          if (response.Ok) {
            if (response.Obj) this.toast.fire('Erfolg', 'Empfänger erfolgreich gelöscht.', 'success').then(r => this.loadReceivers());
            else this.toast.fire('Fehler', 'Empfänger konnte nicht gelöscht werden.', 'error').then(r => this.loadReceivers());
          }
          if (response.Ex) console.log(response.Ex);
          if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
        }), (error: any) => {
          console.log(error);
          this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
        };
      }
    });
  }

  saveEmployee() {
    if (this.employee.UniqueId === 0) {
      this.damageAdministrationService.insertEmployee(this.employee).subscribe(response => {
        if (response.Ok) this.toast.fire('Erfolg', 'Mitarbeiter erstellt.', 'success').then(r => this.loadEmployees());
        else this.toast.fire('Fehler', 'Mitarbeiter wurde nicht erstellt.', 'error').then(r => this.loadEmployees());
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
      }), (error: any) => {
        console.log(error);
        this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
      };
    } else {
      this.damageAdministrationService.updateEmployee(this.employee.UniqueId, this.employee).subscribe(response => {
        if (response.Ok) this.toast.fire('Erfolg', 'Mitarbeiter gespeichert.', 'success').then(r => this.loadEmployees());
        else this.toast.fire('Fehler', 'Mitarbeiter wurde nicht gespeichert.', 'error').then(r => this.loadEmployees());
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
      }), (error: any) => {
        console.log(error);
        this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
      };
    }
    this.cancel();
  }
  saveCarType() {
    if (this.carType.CarTypeId === 0) {
      this.damageAdministrationService.insertCarType(this.carType).subscribe(response => {
        if (response.Ok) this.toast.fire('Erfolg', 'Fahrzeug Modell erstellt.', 'success').then(r => this.loadCarTypes());
        else this.toast.fire('Fehler', 'Fahrzeug Modell wurde nicht erstellt.', 'error').then(r => this.loadCarTypes());
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
      }), (error: any) => {
        console.log(error);
        this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
      }
    } else {
      this.damageAdministrationService.updateCarType(this.carType.CarTypeId, this.carType).subscribe(response => {
        if (response.Ok) this.toast.fire('Erfolg', 'Fahrzeug Modell gespeichert.', 'success').then(r => this.loadCarTypes());
        else this.toast.fire('Fehler', 'Fahrzeug Modell wurde nicht gespeichert.', 'error').then(r => this.loadCarTypes());
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
      }), (error: any) => {
        console.log(error);
        this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
      };
    }
    this.cancel();
  }
  saveCarBrand() {
    if (this.carBrand.CarBrandId === 0) {
      this.damageAdministrationService.insertCarBrand(this.carBrand).subscribe(response => {
        if (response.Ok) this.toast.fire('Erfolg', 'Fahrzeug Marke erstellt.', 'success').then(r => this.loadCarBrands());
        else this.toast.fire('Fehler', 'Fahrzeug Marke wurde nicht erstellt.', 'error').then(r => this.loadCarBrands());
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
      }), (error: any) => {
        console.log(error);
        this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
      };
    } else {
      this.damageAdministrationService.updateCarBrand(this.carBrand.CarBrandId, this.carBrand).subscribe(response => {
        if (response.Ok) this.toast.fire('Erfolg', 'Fahrzeug Marke gespeichert.', 'success').then(r => this.loadCarBrands());
        else this.toast.fire('Fehler', 'Fahrzeug Marke wurde nicht gespeichert.', 'error').then(r => this.loadCarBrands());
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
      }), (error: any) => {
        console.log(error);
        this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
      };
    }
    this.cancel();
  }
  saveImporter() {
    if (this.importer.ImporterId === 0) {
      this.damageAdministrationService.insertImporter(this.importer).subscribe(response => {
        if (response.Ok) this.toast.fire('Erfolg', 'Importeur erstellt.', 'success').then(r => this.loadImporters());
        else this.toast.fire('Fehler', 'Importeur wurde nicht erstellt.', 'error').then(r => this.loadImporters());
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
      }), (error: any) => {
        console.log(error);
        this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
      };
    } else {
      this.damageAdministrationService.updateImporter(this.importer.ImporterId, this.importer).subscribe(response => {
        if (response.Ok) this.toast.fire('Erfolg', response.Msg ?? 'Importeur gespeichert.', 'success').then(r => this.loadImporters());
        else this.toast.fire('Fehler', response.Msg ?? 'Importeur wurde nicht gespeichert.', 'error').then(r => this.loadImporters());
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
      }), (error: any) => {
        console.log(error);
        this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
      };
    }
    this.cancel();
  }
  saveInsurance() {
    if (this.insurance.InsuranceId === 0) {
      this.damageAdministrationService.insertInsurance(this.insurance).subscribe(response => {
        if (response.Ok) this.toast.fire('Erfolg', 'Versicherungsart erstellt.', 'success').then(r => this.loadInsurances());
        else this.toast.fire('Fehler', 'Versicherungsart wurde nicht erstellt.', 'error').then(r => this.loadInsurances());
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
      }), (error: any) => {
        console.log(error);
        this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
      };
    } else {
      this.damageAdministrationService.updateInsurance(this.insurance.InsuranceId, this.insurance).subscribe(response => {
        if (response.Ok) this.toast.fire('Erfolg', 'Versicherungsart gespeichert.', 'success').then(r => this.loadInsurances());
        else this.toast.fire('Fehler', 'Versicherungsart wurde nicht gespeichert.', 'error').then(r => this.loadInsurances());
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
      }), (error: any) => {
        console.log(error);
        this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
      };
    }
    this.cancel();
  }
  saveJobType() {
    if (this.jobType.JobTypeId === 0) {
      this.damageAdministrationService.insertJobType(this.jobType).subscribe(response => {
        if (response.Ok) this.toast.fire('Erfolg', 'Auftragstyp erstellt.', 'success').then(r => this.loadJobTypes());
        else this.toast.fire('Fehler', 'Auftragstyp wurde nicht erstellt.', 'error').then(r => this.loadJobTypes());
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
      }), (error: any) => {
        console.log(error);
        this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
      };
    } else {
      this.damageAdministrationService.updateJobType(this.jobType.JobTypeId, this.jobType).subscribe(response => {
        if (response.Ok) this.toast.fire('Erfolg', 'Auftragstyp gespeichert.', 'success').then(r => this.loadJobTypes());
        else this.toast.fire('Fehler', 'Auftragstyp wurde nicht gespeichert.', 'error').then(r => this.loadJobTypes());
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
      }), (error: any) => {
        console.log(error);
        this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
      };
    }
    this.cancel();
  }
  saveReceiver() {
    if (this.receiver.ReceiverId === 0) {
      this.damageAdministrationService.insertReceiver(this.receiver).subscribe(response => {
        if (response.Ok) this.toast.fire('Erfolg', 'Empfänger erstellt.', 'success').then(r => this.loadReceivers());
        else this.toast.fire('Fehler', 'Empfänger wurde nicht erstellt.', 'error').then(r => this.loadReceivers());
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
      }), (error: any) => {
        console.log(error);
        this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
      };
    } else {
      this.damageAdministrationService.updateReceiver(this.receiver.ReceiverId, this.receiver).subscribe(response => {
        if (response.Ok) this.toast.fire('Erfolg', 'Empfänger gespeichert.', 'success').then(r => this.loadReceivers());
        else this.toast.fire('Fehler', 'Empfänger wurde nicht gespeichert.', 'error').then(r => this.loadReceivers());
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
      }), (error: any) => {
        console.log(error);
        this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
      };
    }
    this.cancel();
  }

  cancel() {
    this.employee = new Employee();
    this.carType = new CarType();
    this.carBrand = new CarBrand();
    this.insurance = new Insurance();
    this.importer = new Importer();
    this.jobType = new JobType();
    this.receiver = new Receiver();
    this.dialog.closeAll();
  }

  toolbarClick($event: ClickEventArgs) {
    if ($event.item.id === 'employeeGrid_excelexport') { this.employeeGrid.excelExport(); }
    if ($event.item.id === 'employeeGrid_pdfexport') { this.employeeGrid.pdfExport(); }
    if ($event.item.id === 'carTypeGrid_excelexport') { this.carTypeGrid.excelExport(); }
    if ($event.item.id === 'carTypeGrid_pdfexport') { this.carTypeGrid.pdfExport(); }
    if ($event.item.id === 'carBrandGrid_excelexport') { this.carBrandGrid.excelExport(); }
    if ($event.item.id === 'carBrandGrid_pdfexport') { this.carBrandGrid.pdfExport(); }
    if ($event.item.id === 'importerGrid_excelexport') { this.importerGrid.excelExport(); }
    if ($event.item.id === 'importerGrid_pdfexport') { this.importerGrid.pdfExport(); }
    if ($event.item.id === 'insuranceGrid_excelexport') { this.insuranceGrid.excelExport(); }
    if ($event.item.id === 'insuranceGrid_pdfexport') { this.insuranceGrid.pdfExport(); }
    if ($event.item.id === 'jobTypeGrid_excelexport') { this.jobTypeGrid.excelExport(); }
    if ($event.item.id === 'jobTypeGrid_pdfexport') { this.jobTypeGrid.pdfExport(); }
    if ($event.item.id === 'receiverGrid_excelexport') { this.receiverGrid.excelExport(); }
    if ($event.item.id === 'receiverGrid_pdfexport') { this.receiverGrid.pdfExport(); }
  }

  // tslint:disable-next-line:only-arrow-functions
  public carBrandComparisonFunction = function(option, value): boolean {
    if (value != null) return option === value;
  };
  // tslint:disable-next-line:only-arrow-functions
  public importerComparisonFunction = function(option, value): boolean {
    if (value != null) return option === value;
  };
}
